import React from 'react';
import { BellIcon, SparklesIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative min-h-[600px] md:min-h-[700px] bg-pulse-navy overflow-hidden" data-id="element-194">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-gradient-to-br from-pulse-navy via-pulse-navy-light to-pulse-navy" data-id="element-195" />

      {/* Animated Shapes */}
      <motion.div animate={{
      y: [0, -20, 0],
      rotate: [0, 5, 0]
    }} transition={{
      duration: 6,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute top-20 left-10 w-32 h-32 bg-pulse-blue/20 rounded-full blur-2xl" data-id="element-196" />
      <motion.div animate={{
      y: [0, 20, 0],
      rotate: [0, -5, 0]
    }} transition={{
      duration: 8,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 1
    }} className="absolute top-40 right-20 w-48 h-48 bg-pulse-orange/20 rounded-full blur-3xl" data-id="element-197" />
      <motion.div animate={{
      y: [0, -15, 0]
    }} transition={{
      duration: 7,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 2
    }} className="absolute bottom-20 left-1/4 w-40 h-40 bg-pulse-yellow/15 rounded-full blur-2xl" data-id="element-198" />

      {/* Geometric Accents */}
      <motion.div animate={{
      rotate: 360
    }} transition={{
      duration: 30,
      repeat: Infinity,
      ease: 'linear'
    }} className="absolute top-32 right-1/4 w-4 h-4 bg-pulse-blue rounded-sm" data-id="element-199" />
      <motion.div animate={{
      rotate: -360
    }} transition={{
      duration: 25,
      repeat: Infinity,
      ease: 'linear'
    }} className="absolute bottom-40 right-1/3 w-3 h-3 bg-pulse-yellow rounded-full" data-id="element-200" />
      <motion.div animate={{
      scale: [1, 1.2, 1]
    }} transition={{
      duration: 4,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute top-1/2 left-16 w-2 h-2 bg-pulse-orange rounded-full" data-id="element-201" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 py-20 md:py-32 flex flex-col items-center justify-center min-h-[600px] md:min-h-[700px]" data-id="element-202">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="text-center" data-id="element-203">
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: 1
        }} transition={{
          delay: 0.3,
          type: 'spring',
          stiffness: 200
        }} className="inline-flex items-center gap-2 bg-pulse-orange/20 border border-pulse-orange/50 backdrop-blur-sm px-4 py-2 rounded-full mb-6" data-id="element-204">
            <SparklesIcon className="h-4 w-4 text-pulse-orange" data-id="element-205" />
            <span className="text-pulse-orange font-bold text-sm tracking-widest uppercase" data-id="element-206">
              🚀 COMING SOON TO MIDLOTHIAN, VA
            </span>
          </motion.div>

          <h2 className="text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-black text-white uppercase tracking-tight leading-none" data-id="element-207">
            <motion.span initial={{
            opacity: 0,
            x: -50
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.4,
            duration: 0.6
          }} className="block" data-id="element-208">
              Get Ready
            </motion.span>
            <motion.span initial={{
            opacity: 0,
            x: 50
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.6,
            duration: 0.6
          }} className="block bg-gradient-to-r from-pulse-blue via-pulse-yellow to-pulse-orange bg-clip-text text-transparent" data-id="element-209">
              To Play
            </motion.span>
          </h2>

          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.7,
          type: 'spring'
        }} className="mt-6 mb-4 inline-block" data-id="element-210">
            <div className="bg-white text-pulse-navy font-black text-xl md:text-2xl px-6 py-2 rounded-lg shadow-[0_0_30px_rgba(250,204,21,0.4)] border-2 border-pulse-yellow animate-pulse-slow" data-id="element-211">
              OPENING 2027
            </div>
          </motion.div>

          <motion.p initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.8,
          duration: 0.6
        }} className="mt-4 text-lg md:text-xl text-white/80 max-w-2xl mx-auto" data-id="element-212">
            Midlothian's newest family entertainment destination is almost here.
            12 incredible attractions under one roof — trampolines, go-karts,
            bowling, gaming, and so much more.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 1,
          duration: 0.6
        }} className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-213">
            <a href="#signup" className="group flex items-center gap-2 bg-pulse-orange hover:bg-orange-500 text-white px-8 py-4 rounded-full font-bold uppercase tracking-wide transition-all hover:scale-105 hover:shadow-lg hover:shadow-pulse-orange/30" data-id="element-214">
              <BellIcon className="h-5 w-5" data-id="element-215" />
              Get Notified
            </a>
            <a href="#attractions" className="group flex items-center gap-2 border-2 border-pulse-yellow text-pulse-yellow hover:bg-pulse-yellow hover:text-pulse-navy px-8 py-4 rounded-full font-bold uppercase tracking-wide transition-all hover:scale-105" data-id="element-216">
              See What's Coming
            </a>
          </motion.div>
        </motion.div>

        {/* Scroll Indicator */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.5
      }} className="absolute bottom-8 left-1/2 -translate-x-1/2" data-id="element-217">
          <motion.div animate={{
          y: [0, 10, 0]
        }} transition={{
          duration: 2,
          repeat: Infinity
        }} className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2" data-id="element-218">
            <motion.div animate={{
            y: [0, 12, 0]
          }} transition={{
            duration: 2,
            repeat: Infinity
          }} className="w-1.5 h-1.5 bg-white rounded-full" data-id="element-219" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}